import initialState from "./initialState";

export const types = {
  reset: "reset",
  SET_REQUEST_PROGRESS: "SET_REQUEST_PROGRESS",
  SET_REQUEST_CATEGORICAL_PROGRESS: "SET_REQUEST_CATEGORICAL_PROGRESS",
  SET_SAVE_IN_PROGRESS: "SET_SAVE_IN_PROGRESS",
  SET_TEMP_FLAG: "SET_TEMP_FLAG",
  SET_PUBLIC_FLAG: "SET_PUBLIC_FLAG",
  SET_MAGIC_LINK: "SET_MAGIC_LINK",
};

export default {
  [types.reset]: state => {
    Object.keys(initialState()).forEach(key => {
      state[key] = initialState()[key];
    });
  },
  [types.SET_REQUEST_PROGRESS]: (state, value) => {
    state.isRequestInProgress = value;
  },
  [types.SET_REQUEST_CATEGORICAL_PROGRESS]: (state, value) => {
    state.isCategoricalRequestInProgress = value;
  },
  [types.SET_SAVE_IN_PROGRESS]: (state, value) => {
    state.isSaveInProgress = value;
  },
  [types.SET_TEMP_FLAG]: (state, value) => {
    state.isTemp = value;
  },
  [types.SET_PUBLIC_FLAG]: (state, value) => {
    state.isPublic = value;
  },
  [types.SET_MAGIC_LINK]: (state, value) => {
    state.magicLink = value;
  },
};
